<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span><svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>{{data.title}}</h2>
<div modal-content>
    <p>{{data.body}}</p>
</div>
<div modal-actions alignment="between">
    <button *ngIf="data.ontkenning !== null" class="btn btn--link" (click)="dismiss()">{{data.ontkenning}}</button>
    <button *ngIf="data.bevestiging !== null" class="btn btn--primary" (click)="close()">{{data.bevestiging}}</button>
</div>